export { SeoSerpPage } from './seo-serp-page';
